import * as React from 'react'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline'
}

export function Badge({ className = '', variant = 'default', ...props }: BadgeProps) {
  const base =
    'inline-flex items-center rounded-none border-2 px-2.5 py-0.5 font-display text-xs font-bold uppercase transition-none'

  // The border colour belongs to the variant, not the base: this component has
  // no class-merge step, so two competing border-* classes would be resolved by
  // stylesheet order rather than by intent.
  const variants: Record<string, string> = {
    default: 'border-pixel-outline bg-primary text-primary-foreground',
    secondary: 'border-pixel-outline bg-secondary text-secondary-foreground',
    destructive: 'border-pixel-outline bg-destructive text-destructive-foreground',
    // Lighter than --border: this variant has no fill, so the outline is the
    // only thing carrying its meaning and needs 3:1 against the background.
    outline: 'border-muted-foreground text-foreground',
  }

  return (
    <span className={`${base} ${variants[variant] ?? variants.default} ${className}`} {...props} />
  )
}
